import Helper from './Helper';

class BackToTop {
  constructor() {
      const backToTopNodelist = document.querySelectorAll('.js-back-to-top');
      const backToTop = Array.prototype.slice.call(backToTopNodelist);
      if(!!backToTop){

        window.addEventListener('scroll', () => {
          if(window.scrollY > 500){
            backToTop.forEach(item => {
              item.style.opacity = 1;
            });
          } else{
            backToTop.forEach(item => {
              item.style.opacity = 0;
            });
          }
        });

        backToTop.forEach(item => {
          item.addEventListener('click', (e) => {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              left: 0,
              behavior: 'smooth'
            });
          });
        })
      }
  }
} export default BackToTop;
